import React from 'react';
import SocialMedia from './SocialMedia';

const Profile = (props) => {
    const { name, image, languages, description ,email} = props;

    return (
        <div className="bg-white rounded-lg shadow-lg p-3 py-4 overflow-hidden">
            <div className="w-36 h-36 rounded-full mx-auto">
                <img className="w-full h-full object-cover rounded-full" src={image} alt={name} />
            </div>
            <div className="flex flex-col space-y-2 border-b border-gray-300 pb-4 pt-3">
                <h1 className="text-center text-xl text-gray-700 font_poppins">{name}</h1>
                <p className="text-center font_poppins text-indigo-700 font-semibold text-sm">{languages}</p>

                <p className="text-sm font_poppins text-gray-500 text-center">{description}</p>

                <div className="flex justify-center">
                    <span className="text-white text-sm bg-indigo-700 rounded-md px-3 py-1 w-36">{email}</span>
                </div>
            </div>
            {/* social media icons  */}
            <div className="flex justify-center items-center space-x-2 pt-3">
                {/* icons  */}
                <SocialMedia />
            </div>
        </div>
    )
}

export default Profile
